<template>
	<div class="videolist">
		<div class="breadcrumb">APP列表</div>
		<div class="searchBtn">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>新建APP</el-button>
	    </div>
	    <el-table ref="multipleTable" :data="tableData" highlight-current-row  style="width: 100%">
		    <el-table-column prop="id" label="ID" width="80"></el-table-column>
		    <el-table-column prop="type" label="APP类型">
		    	<template slot-scope="scope">
		    		{{scope.row.type==1?'安卓屏端':scope.row.type==2?'安卓手机端':'苹果手机端'}}
		    	</template>
		    </el-table-column>
		    <el-table-column prop="os" label="系统类型">
		    	<template slot-scope="scope">
		    		{{scope.row.os==1?'安卓':'IOS'}}
		    	</template>
		    </el-table-column>
		    <el-table-column prop="sportsKindId" label="运动类型">
		    	<template slot-scope="scope">
		    		{{scope.row.sportsKindId==1?'单车':scope.row.sportsKindId==2?'跑步机':scope.row.sportsKindId==3?'健身':scope.row.sportsKindId==4?'瑜伽':'居家'}}
		    	</template>
		    </el-table-column>
		    <el-table-column prop="screenSize" label="屏幕尺寸"></el-table-column>
		    <el-table-column prop="oemTypeName" label="主板厂商"></el-table-column>
		    <el-table-column prop="tag" label="版本名称(tag)"></el-table-column>
		    <el-table-column prop="versionNum" label="版本号(version)"></el-table-column>
		    <el-table-column prop="versionDesc" label="升级内容"></el-table-column>
		    <el-table-column prop="updateTime" :formatter="this.global.dateFormat" label="升级日期" width="200"></el-table-column>
		    <el-table-column label="操作">
		      	<template slot-scope="scope">
		      		<i class="el-icon-edit" style="cursor:pointer" title="新建版本" @click="addVersion(scope.row)"></i>
		      		<i class="el-icon-more-outline" title="版本历史" style="margin-left:10px;cursor:pointer" @click="versionHistory(scope.row)"></i>
		      	</template>
		    </el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>

		<!-- 新建APP弹框 -->
    	<el-dialog title="新建APP" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="120px">
      			<el-form-item label="APP类型" prop="type">
				    <el-select v-model="ruleForm.type" placeholder="请选择APP类型" style="width: 80%;" @change="typeMapval">
		            	<el-option v-for="item in getAppData.typeMap" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
		          	</el-select>
				</el-form-item>

				<input type="hidden" v-model="ruleForm.os" />
		        <el-form-item label="系统类型" prop="os">
		        	<el-input type="text" v-model="ruleForm.osname" :disabled="true" placeholder="系统类型"></el-input>
		        </el-form-item>

		        <el-form-item label="运动类型" prop="sportsKindId">
				    <el-select v-model="ruleForm.sportsKindId" placeholder="请选择运动类型" style="width: 80%;">
		            	<el-option v-for="item in getAppData.sportKindMap" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
		          	</el-select>
				</el-form-item>
				<el-form-item label="屏幕尺寸" prop="screenSize">
				    <el-select v-model="ruleForm.screenSize" placeholder="请选择屏幕尺寸" style="width: 80%;">
		            	<el-option v-for="item in getAppData.screenSizeMap" :key="item.name" :label="item.name" :value="item.name">{{item.name}}</el-option>
		          	</el-select>
				</el-form-item>
				<el-form-item label="主板厂商" prop="oemType">
				    <el-select v-model="ruleForm.oemType" placeholder="请选择主板厂商" style="width: 80%;">
		            	<el-option v-for="item in getAppData.oemTypeMap" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
		          	</el-select>
				</el-form-item>

		        <el-form-item label="新包地址" prop="url">
		        	<el-input v-model="ruleForm.url" placeholder="请输入新包URL地址"></el-input>
				</el-form-item>
				<el-form-item label="版本名称" prop="tag">
		        	<el-input v-model="ruleForm.tag" placeholder="请输入版本名称(tag)"></el-input>
				</el-form-item>
				<el-form-item label="版本号" prop="versionNum">
		        	<el-input v-model="ruleForm.versionNum" placeholder="请输入版本号需是整数(version)"></el-input>
				</el-form-item>
				<el-form-item label="升级内容" prop="versionDesc">
					<el-input type="textarea" v-model="ruleForm.versionDesc" style="width:80%" :rows="4" placeholder="请输入升级内容"></el-input>
				</el-form-item>
		        
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
		    </span>
    	</el-dialog>

    	<!-- 新建版本弹框 -->
    	<el-dialog title="新建版本" :visible.sync="dialogVisible2" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" status-icon label-width="120px">
      			<el-form-item label="APP类型" style="margin:0">
      				{{addVersionVal.type==1?'安卓屏端':addVersionVal.type==2?'安卓手机端':'苹果手机端'}}
      			</el-form-item>
		        <el-form-item label="系统类型" style="margin:0">
		        	{{addVersionVal.os==1?'安卓':'IOS'}}
		        </el-form-item>
		        <el-form-item label="运动类型" style="margin:0">
		        	{{addVersionVal.sportsKindId==1?'单车':addVersionVal.sportsKindId==2?'跑步机':addVersionVal.sportsKindId==3?'健身':addVersionVal.sportsKindId==4?'瑜伽':'居家'}}
		        </el-form-item>
		        <el-form-item label="屏幕尺寸" style="margin:0">{{addVersionVal.screenSize}}</el-form-item>
		        <el-form-item label="主板厂商" >{{addVersionVal.oemTypeName}}</el-form-item>
		        <el-form-item label="新包地址" prop="url">
		        	<el-input v-model="ruleForm2.url" placeholder="请输入新包URL地址"></el-input>
				</el-form-item>
				<el-form-item label="版本名称" prop="tag">
		        	<el-input v-model="ruleForm2.tag" placeholder="请输入版本名称(tag)"></el-input>
				</el-form-item>
				<el-form-item label="版本号" prop="versionNum">
		        	<el-input v-model="ruleForm2.versionNum" placeholder="请输入版本号(version)"></el-input>
				</el-form-item>
				<el-form-item label="升级内容" prop="versionDesc">
					<el-input type="textarea" v-model="ruleForm2.versionDesc" style="width:80%" :rows="4" placeholder="请输入升级内容"></el-input>
				</el-form-item>
		        
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible2 = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit2('ruleForm2')">确 定</el-button>
		    </span>
    	</el-dialog>
    
    	<!-- 版本历史弹框 -->
    	<el-dialog title="版本历史" :visible.sync="dialogVisible3" width="55%" :before-close="handleClose" class="stagecon">
      		<div class="stagetit">
		        <span>APP类型: {{versionval.type==1?'安卓屏端':versionval.type==2?'安卓手机端':'苹果手机端'}}</span>
		        <span>运动类型: {{versionval.sportsKindId==1?'单车':versionval.sportsKindId==2?'跑步机':versionval.sportsKindId==3?'健身':versionval.sportsKindId==4?'瑜伽':'居家'}}</span>
		        <span>主板厂商: {{versionval.oemTypeName}}</span>
		        <span>系统类型: {{versionval.os==1?'安卓':'IOS'}}</span>
		        <span>屏幕尺寸: {{versionval.screenSize}}</span>
	      	</div>

	      	<el-table ref="multipleTable" :data="tableData3" highlight-current-row  style="width: 100%">
			    <el-table-column prop="tag" label="版本名称(tag)"></el-table-column>
			    <el-table-column prop="versionNum" label="版本号(version)"></el-table-column>
			    <el-table-column prop="versionDesc" label="升级内容"></el-table-column>
			    <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建日期" width="200"></el-table-column>
			    <el-table-column prop="updateTime" :formatter="this.global.dateFormat" label="升级日期" width="200"></el-table-column>
			    <el-table-column label="状态">
					<template slot-scope="scope">
						<div v-if="scope.row.versionStatus==true">
							最新版
						</div>
			      		<el-button size='small' type="primary" plain v-else @click="releaseVersion(scope.row.appId,scope.row.id)">发布</el-button>
			      	</template>
			    </el-table-column>
			</el-table>

		  	<div style="margin-top: 20px;">
		    	<div style="float:right">
				    <el-pagination @current-change="handleCurrentChangePage3" :current-page="pageNum3" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage3"></el-pagination>
				</div>
				<div style="clear:both"></div>
			</div>
    	</el-dialog>


	</div>
</template>
<script>
export default {
  	mounted() {
  		this.getAppDeDict();
  		this.init(); 	
  	},
  	data() {
  		var regval = (rule, value, callback) => {//包含小数的数字
            let reg = /^[1-9]\d*$/;
            if (value === '') {
                callback(new Error('请输入版本号'));
            } else if (!reg.test(value)) {
                callback(new Error('版本号必须为整数'));
            } else {
                callback();
            }
        };
    	return {
    		pageNum: 1,
    		pageNum3:1,
		    limit: 10,
		    totalPage: 10,
		    totalPage3: 10,
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tableData:[],
	      	tableData3: [],
	      	dialogVisible: false,
	      	ruleForm: {},
	      	ruleForm2:{},
      		rules:{
      			os:[
		            { required: true, message: '请输入系统类型', trigger: 'blur' }
		        ],
		        type:[
		            { required: true, message: '请选择APP类型', trigger: 'change' }
		        ],
		        sportsKindId:[
		            { required: true, message: '请选择运动类型', trigger: 'change' }
		        ],
		        screenSize:[
		            { required: true, message: '请选择屏幕尺寸', trigger: 'change' }
		        ],
		        oemType:[
		            { required: true, message: '请选择主板厂商', trigger: 'change' }
		        ],
		        url:[
		            { required: true, message: '请输入新包URL地址', trigger: 'blur' }
		        ],
		        tag:[
		            { required: true, message: '请输入版本名称', trigger: 'blur' }
		        ],
		        versionNum:[
		            { required: true, validator:regval, trigger: 'blur' }
		        ],
		        versionDesc:[
		            { required: true, message: '请输入升级内容', trigger: 'blur' }
		        ],
      		},
      		rules2:{
      			url:[
		            { required: true, message: '请输入新包URL地址', trigger: 'blur' }
		        ],
		        tag:[
		            { required: true, message: '请输入版本名称', trigger: 'blur' }
		        ],
		        versionNum:[
		            { required: true, validator:regval, trigger: 'blur' }
		        ],
		        versionDesc:[
		            { required: true, message: '请输入升级内容', trigger: 'blur' }
		        ]
      		},
      		dialogVisible2:false,
      		dialogVisible3:false,
      		getAppData:[],
      		versionval:'',
      		addVersionVal:''
	    };
  	},
  	methods:{
  		getAppDeDict(){
      		this.$get("/appVersion/getAppDetailDictionary")
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
          			this.getAppData=res.data;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		typeMapval(val){
  			console.log(val)
  			if(val==1 || val==2){
  				this.ruleForm.os=1;
  				this.ruleForm.osname='安卓'
  			}else{
  				this.ruleForm.os=2;
  				this.ruleForm.osname='IOS'
  			}
  		},
  		onSubmit(formName){
	  		this.$refs[formName].validate((valid) => {
	          	if (valid) {  
	            	this.$post("/appVersion/addOrUpdAppDetail", JSON.stringify(this.ruleForm))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: "添加成功",
	                    		type: "success"
	                  		});		                  		
	                  		this.$refs.ruleForm.resetFields();
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	} else {
	            	console.log("error submit!!");
	            	return false;
	          	}
	    	});
	    },
	    onSubmit2(formName){
	    	this.$refs[formName].validate((valid) => {
	          	if (valid) {
	          		this.ruleForm2.appId=this.addVersionVal.id;
	          		this.ruleForm2.userId=localStorage.getItem("userId")
	            	this.$post("/appVersion/addOrUpdAppVersionDetail", JSON.stringify(this.ruleForm2))
	              	.then(res => {
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: "添加成功",
	                    		type: "success"
	                  		});		                  		
	                  		this.$refs.ruleForm2.resetFields();
	                  		this.dialogVisible2 = false;
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	          	} else {
	            	console.log("error submit!!");
	            	return false;
	          	}
	    	});
	    },
  		init(){//视频列表
  			var params = {
        		pageNum: this.pageNum,
        		limit: this.limit
      		};
      		this.$get("/appVersion/getAppDetailList", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		//当前页数
	    handleCurrentChangePage(val) {
	    	this.pageNum = val;
	      	this.init()
	    },
	    handleCurrentChangePage3(val){
	    	this.pageNum3 = val;
	    	this.getAppVerDeList();
	    },
  		add(row){
  			this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	      		this.ruleForm={
	      		}
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	this.currentRow='';
	      	this.dialogVisible = true;
  		},
	    addVersion(row){
	    	this.addVersionVal=row;
	    	this.dialogVisible2=true
	    },
	    versionHistory(row){
	    	this.versionval=row;
	    	if(this.versionval.id){
	    		this.getAppVerDeList();
	    	}
	    },
	    getAppVerDeList(){
	    	var params = {
        		pageNum: this.pageNum3,
        		limit: this.limit,
        		appId:this.versionval.id
      		};
      		this.$get("/appVersion/getAppVersionDetailList", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData3 = res.data.list;
            		this.totalPage3 = res.data.total;
            		this.dialogVisible3=true
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
	    },
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	this.ruleForm={
			        
		      	}
	      	}
	      	done();
	    },
	    releaseVersion(appId,id){
	    	var data={
	    		appId:appId,
	    		versionId:id,
	    		userId:localStorage.getItem("userId")
	    	}
	    	this.$post("/appVersion/releaseVersion", JSON.stringify(data))
          	.then(res => {
            	if (res.code == 0) {
              		this.$message({
                		message: '发布成功',
                		type: "success"
              		});
              		this.dialogVisible3 = false;
              		this.pageNum = 1;
	                this.init();
            	} else {
              		this.$message({
                		message: res.message,
                		type: "warning"
              		});
              		return false;
            	}
          	})
	    }
  	}
}
</script>
<style scoped>
.el-input {
  	width: 80%;
}
::deep
.stagecon .el-dialog__body{
	padding: 10px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/versionManagement/appList.vue